export default __webpack_public_path__ + "static/TiemposBold-fcb0c39e44d7fc1fb96e04fcb542e0d6.woff";